'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialEuro = function IoSocialEuro(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.3 21.3h9.7l-0.6 3.7h-9.1v1c0 3.5 1.2 4.9 6.2 4.9 2 0 4.3-0.2 7.2-0.7l0.8 5.1c-3 0.7-5.6 1-8.3 1-9 0-12.8-3.3-12.8-9.2v-2.1h-3.9v-3.7h3.9v-3.8h-3.9v-3.7h3.9v-0.9c0-5.9 3.8-9.1 12.8-9.1 2.8 0 5.3 0.2 8.3 0.9l-0.8 5.1c-2.9-0.5-5.2-0.7-7.2-0.7-5 0-6.2 1.7-6.2 4.5v0.2h10.8l-0.6 3.7h-10.2v3.8z' })
        )
    );
};

exports.default = IoSocialEuro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-euro.js
// module id = 2918
// module chunks = 168707334958949